import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { cn } from "../utils/styleHelper";
import { Calendar } from "./Calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
export function DatePicker({ date, onDateChange, placeholder = "Pick a date", disabled = false, className }) {
    return /*#__PURE__*/ _jsxs(Popover, {
        children: [
            /*#__PURE__*/ _jsx(PopoverTrigger, {
                asChild: true,
                children: /*#__PURE__*/ _jsxs("button", {
                    type: "button",
                    disabled: disabled,
                    className: cn("w-full h-11 px-4 py-2.5 sm:h-9 sm:px-3 sm:py-1.5 text-sm leading-5 bg-white border border-gray-300 rounded-lg text-left font-normal flex items-center gap-2", "shadow-sm transition-all duration-200 hover:border-gray-400", "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500", !date && "text-gray-500", "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50", className),
                    children: [
                        /*#__PURE__*/ _jsx(CalendarIcon, {
                            className: "h-4 w-4 flex-shrink-0 text-gray-400"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "flex-1",
                            children: date ? format(date, "PPP") : placeholder
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(PopoverContent, {
                className: "w-auto p-0",
                align: "start",
                children: /*#__PURE__*/ _jsx(Calendar, {
                    mode: "single",
                    required: false,
                    selected: date,
                    onSelect: onDateChange ?? (()=>{}),
                    ...date ? {
                        defaultMonth: date
                    } : {}
                })
            })
        ]
    });
}
